// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".report-modal-overlay{background-color:rgba(0,0,0,.5);bottom:0!important;left:0!important;position:fixed!important;right:0!important;top:0!important;z-index:9999!important}.report-modal-content{z-index:10000!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
